import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "site-content" }
const _hoisted_2 = { class: "section-content" }
const _hoisted_3 = { class: "container" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col-md-8 ml-md-auto mr-md-auto" }
const _hoisted_6 = /*#__PURE__*/_createStaticVNode("<h4 class=\"text-center\">Available Vouchers</h4><p class=\"text-center mb-3\">Select your preferred voucher below. Once you have chosen a voucher, you will be redirected to PayPal where you will be able to pay with either your PayPal account, or with a debit/credit card.</p><p class=\"text-center mb-3\"><img src=\"https://www.paypalobjects.com/webstatic/mktg/logo/bdg_payments_by_pp_2line.png\"></p><p class=\"text-center mb-3\">After your payment is processed it can take up to 24 hours to create your unique voucher code, and this will be sent to the email address provided via the payment process.</p>", 4)
const _hoisted_10 = { key: 0 }
const _hoisted_11 = /*#__PURE__*/_createVNode("input", {
  type: "hidden",
  name: "cmd",
  value: "_s-xclick"
}, null, -1)
const _hoisted_12 = {
  type: "submit",
  class: "btn btn-lg btn-primary",
  name: "submit"
}
const _hoisted_13 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_14 = /*#__PURE__*/_createVNode("img", {
  alt: "",
  border: "0",
  src: "https://www.paypalobjects.com/en_GB/i/scr/pixel.gif",
  width: "1",
  height: "1"
}, null, -1)
const _hoisted_15 = { key: 1 }
const _hoisted_16 = /*#__PURE__*/_createVNode("input", {
  type: "hidden",
  name: "cmd",
  value: "_s-xclick"
}, null, -1)
const _hoisted_17 = {
  type: "submit",
  class: "btn btn-lg btn-primary",
  name: "submit"
}
const _hoisted_18 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_19 = /*#__PURE__*/_createVNode("img", {
  alt: "",
  border: "0",
  src: "https://www.paypalobjects.com/en_GB/i/scr/pixel.gif",
  width: "1",
  height: "1"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_page_header = _resolveComponent("page-header")
  const _component_booking_details = _resolveComponent("booking-details")

  return (_openBlock(), _createBlock("div", null, [
    _createVNode(_component_page_header, {
      image: "ladder",
      title: "Vouchers"
    }),
    _createVNode("main", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("div", _hoisted_3, [
          _createVNode(_component_booking_details, { voucherLink: false }),
          _createVNode("div", _hoisted_4, [
            _createVNode("div", _hoisted_5, [
              _hoisted_6,
              (_ctx.location === 'middlesbrough')
                ? (_openBlock(), _createBlock("div", _hoisted_10, [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.middlesbrough, (voucher, i) => {
                      return (_openBlock(), _createBlock("form", {
                        key: i,
                        class: "voucher mb-3",
                        action: "https://www.paypal.com/cgi-bin/webscr",
                        method: "post",
                        target: "_top"
                      }, [
                        _hoisted_11,
                        _createVNode("input", {
                          type: "hidden",
                          name: "hosted_button_id",
                          value: voucher.code
                        }, null, 8, ["value"]),
                        _createVNode("button", _hoisted_12, [
                          _createTextVNode("Purchase " + _toDisplayString(voucher.players) + " Player Voucher", 1),
                          _hoisted_13,
                          _createTextVNode("@ " + _toDisplayString(this.location.charAt(0).toUpperCase() + this.location.slice(1)), 1)
                        ]),
                        _hoisted_14
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true),
              (_ctx.location === 'hexham')
                ? (_openBlock(), _createBlock("div", _hoisted_15, [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.hexham, (voucher, i) => {
                      return (_openBlock(), _createBlock("form", {
                        key: i,
                        class: "voucher mb-3",
                        action: "https://www.paypal.com/cgi-bin/webscr",
                        method: "post",
                        target: "_top"
                      }, [
                        _hoisted_16,
                        _createVNode("input", {
                          type: "hidden",
                          name: "hosted_button_id",
                          value: voucher.code
                        }, null, 8, ["value"]),
                        _createVNode("button", _hoisted_17, [
                          _createTextVNode("Purchase " + _toDisplayString(voucher.players) + " Player Voucher", 1),
                          _hoisted_18,
                          _createTextVNode("@ " + _toDisplayString(this.location.charAt(0).toUpperCase() + this.location.slice(1)), 1)
                        ]),
                        _hoisted_19
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ])
    ])
  ]))
}